import { FC } from "react";

import { ISettingOptions } from "../../../types/interfaces";

import styles from "../headerBtn.module.scss";

const VacancyListSettingsSection: FC<ISettingOptions> = ({
  setSelectedSettings,
  selectedSettings,
  setIsCheckedFullInfo,
  isCheckedFullInfo,
}) => {

  const options = [
    { value: 'vacancyId', label: 'ID' },
    { value: 'type', label: 'Тип вакансии' },
    { value: 'regions', label: 'Регион' },
    { value: 'areas', label: 'Область' },
    { value: 'cities', label: 'Город' },
    { value: 'addresses', label: 'Адрес' },
    { value: 'subway', label: 'Метро/Район' },
    { value: 'merchs', label: 'Логин/локация' },
    { value: 'vacancyName', label: 'Название вакансии' },
    { value: 'status', label: 'Статус' },
    { value: 'projectName', label: 'Проект' },
    { value: 'routeNo', label: 'Маршрут' },
    { value: 'vsv', label: 'ВСВ' },
    { value: 'sv', label: 'Супервайзер' },
    { value: 'schedule', label: 'График' },
    { value: 'salary', label: 'Зарплата' },
    { value: 'revenue', label: 'Выручка' },
    { value: 'razm', label: 'Размещена' },
    { value: 'createdDate', label: 'Дата создания вакансии' },
    { value: 'modifiedDate', label: 'Дата изменения вакансии' },
  ];

  const handleChangeCheckbox = (name: string) => {
    const updatedSettings = selectedSettings.includes(name)
      ? selectedSettings.filter((elem: string) => elem !== name)
      : [...selectedSettings, name];

    setSelectedSettings(updatedSettings);
    setIsCheckedFullInfo(false);
  };

  const handleChangeFullInfoCheckbox = () => {
    if (!isCheckedFullInfo) {
      const allSettings = options.map((option) => option.value);
      setSelectedSettings(allSettings);
    } else {
      setSelectedSettings([]);
    }
    setIsCheckedFullInfo(!isCheckedFullInfo);
  };

  return (
    <div className={styles.settings__block_info}>
      <div className={styles.check__list_block}>
        {options.map((option) => (
          <div key={option.value} className={styles.check__list_elem}>
            <label className={styles.checkbox__container}>
              <input
                checked={selectedSettings.includes(option.value)}
                type="checkbox"
                onChange={() => handleChangeCheckbox(option.value)}
              />
              <span className={styles.multi__reason_checkmark}></span>
            </label>
            {option.label}
          </div>
        ))}
        <div className={styles.check__list_elem}>
          <label className={styles.checkbox__container}>
            <input
              type={"checkbox"}
              onChange={handleChangeFullInfoCheckbox}
              checked={isCheckedFullInfo || (options.length === selectedSettings.length)}
            />
            <span className={styles.multi__reason_checkmark}></span>
          </label>
          Все
        </div>
      </div>
    </div>
  );
};

export default VacancyListSettingsSection;
